export default "__VITE_ASSET__df7945ce__"